var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationOutline = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 18,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M.292 0h13.125v18H.292z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.034 5.355c.236 1.137.12 2.287-.296 3.53-.464 1.385-1.158 2.708-2.167 4.244a35.922 35.922 0 0 1-2.865 3.775l-.485.55-.086.09-.016.012-.015.017-.045.037-.034.024-.049.028-.088.038-.04.011-.052.011-.041.005-.094.002-.052-.006-.041-.008-.051-.014-.04-.014-.049-.022-.037-.02-.046-.031-.033-.026-.043-.04-.679-.786-.242-.286-.11-.133c-1.609-1.949-2.812-3.695-3.74-5.521C.92 9.685.54 8.652.354 7.592c-.47-2.648.909-5.354 3.349-6.595 3.835-1.95 8.468.199 9.33 4.358zM4.246 2.126c-1.958.996-3.057 3.154-2.687 5.24.163.92.5 1.84 1.024 2.872.818 1.61 1.87 3.167 3.262 4.89l.432.527.43.505.083-.093a35.211 35.211 0 0 0 2.41-3.113l.356-.53c.954-1.452 1.6-2.684 2.024-3.949.348-1.041.441-1.965.256-2.857-.692-3.339-4.457-5.085-7.59-3.492zm2.51 1.793A2.66 2.66 0 0 1 9.4 6.602c-.016 1.47-1.237 2.636-2.71 2.617-1.505-.018-2.7-1.205-2.672-2.696.026-1.481 1.242-2.62 2.738-2.604zm-.012 1.26c-.84-.009-1.488.597-1.502 1.367-.013.732.555 1.336 1.331 1.407l.131.006.134-.004c.703-.052 1.26-.582 1.33-1.242l.007-.125c.009-.765-.624-1.4-1.431-1.409z",
  fill: "#7D7D7D",
  fillRule: "nonzero",
  mask: "url(#b)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationOutline);
export default ForwardRef;